import moment from 'moment'
export default {
  sortArray(data, sortOn, dir) {
    let _data
    if (sortOn !== undefined && dir !== undefined) {
      _data = data.sort((a, b) => {
        const x = a[sortOn]
        const y = b[sortOn]
        if (dir.toUpperCase() === 'ASC') {
          return x < y ? -1 : x > y ? 1 : 0
        }
        if (dir.toUpperCase() === 'DESC') {
          return x > y ? -1 : x < y ? 1 : 0
        }
        return null
      })
    } else {
      _data = Array.from(new Set(data)).sort(function (a, b) {
        if (a[0] === b[0]) {
          var x = a['name']
          var y = b['name']
          return x < y ? -1 : x > y ? 1 : 0
        }
        return a[0] - b[0]
      })
    }
    return _data
  },
  sortArray2(data) {
    let _data = Array.from(new Set(data)).sort(function (a, b) {
      if (a[0] === b[0]) {
        var x = a['name']
        var y = b['name']
        return x < y ? -1 : x > y ? 1 : 0
      }
      return a[0] - b[0]
    })
    return _data
  },
  isNumeric: function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n)
  },
  isObject(objValue) {
    return objValue && typeof objValue === 'object' && objValue.constructor === Object
  },
  formatNumber: function (value, places) {
    let result = 0
    try {
      if (places === undefined || places === null) {
        places = 2
      }
      if (places === 0) {
        result = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        result = value.toFixed(places).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      }
      return result
    } catch (e) {
      console.log('Error: formatNumber', e)
    }
  },
  formatDate(date, type = '') {
    let _date = null
    try {
      if (date !== undefined && date !== null) {
        _date = moment.utc(date).local().format(type === 'datetime' ? 'MM/DD/YYYY hh:mm a' : 'MM/DD/YYYY')
      }
      return _date
    } catch (e) {
      console.log('Error: formatDate', e)
    }
  },
  isJson(str) {
    try {
      JSON.parse(str)
    } catch (e) {
      return false
    }
    return true
  },
  isParsedJson(variable) {
    if (variable === undefined || variable === null) {
      return false
    }
    if (typeof variable === 'object' && !Array.isArray(variable)) {
      return true
    }
    if (Array.isArray(variable)) {
      return true
    }
    return false
  },
  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array)
    }
  },
  pastDayRange() {
    let _range = null
    _range = {
      start: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      end: moment().format('YYYY-MM-DD')
    }
    return _range
  },
  weekRange() {
    let _range = null
    _range = {
      start: moment().startOf('week').format('YYYY-MM-DD'),
      end: moment().endOf('week').format('YYYY-MM-DD')
    }
    return _range
  },
  monthRange() {
    let _range = null
    _range = {
      start: moment().startOf('month').format('YYYY-MM-DD'),
      end: moment().endOf('month').format('YYYY-MM-DD')
    }
    return _range
  },
  qtrRange() {
    let _range = null
    let qtr = moment().quarter()
    _range = {
      start: moment().quarter(qtr).startOf('quarter').format('YYYY-MM-DD'),
      end: moment().quarter(qtr).endOf('quarter').format('YYYY-MM-DD')
    }
    return _range
  },
  past6months() {
    let _range = null
    _range = {
      start: moment().subtract(6, 'months').startOf('month').format('YYYY-MM-DD'),
      end: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
    }
    return _range
  },
  sixmonthRange() {
    let _range = null
    let qtr = moment().quarter()
    if (qtr === 1 || qtr === 2) {
      _range = {
        start: moment().startOf('year').format('YYYY-MM-DD'),
        end: moment(`${moment().year()}-06-30`).format('YYYY-MM-DD')
      }
    } else {
      _range = {
        start: moment(`${moment().year()}-06-01`).format('YYYY-MM-DD'),
        end: moment().endOf('year').format('YYYY-MM-DD')
      }
    }
    return _range
  },
  pastYear() {
    let _range = null
    _range = {
      start: moment().subtract(12, 'months').startOf('month').format('YYYY-MM-DD'),
      end: moment().endOf('month').format('YYYY-MM-DD')
    }
    return _range
  },
  yearRange() {
    let _range = null
    _range = {
      start: moment().startOf('year').format('YYYY-MM-DD'),
      end: moment().endOf('year').format('YYYY-MM-DD')
    }
    return _range
  },
  pivot(arr) {
    var mp = new Map()

    function setValue(a, path, val) {
      if (Object(val) !== val) {
        // primitive value
        var pathStr = path.join('.')
        var i = (mp.has(pathStr) ? mp : mp.set(pathStr, mp.size)).get(pathStr)
        a[i] = val
      } else {
        for (var key in val) {
          setValue(a, key === '0' ? path : path.concat(key), val[key])
        }
      }
      return a
    }

    var result = arr.map((obj) => setValue([], [], obj))
    return [[...mp.keys()], ...result]
  },
  toCsv(arr) {
    return arr.map((row) => row.map((val) => (isNaN(val) ? JSON.stringify(val) : +val)).join(',')).join('\n')
  }
}



// WEBPACK FOOTER //
// ./src/plugins/globals.js